import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { EmptyEmailTemplate } from "./EmptyEmailTemplate";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Toast } from "primereact/toast";

const schema = yup.object({
    template_Name: yup.string().required("Template Name is required*"),
    template_Subject: yup.string().required("Template Subject is required*"),
    is_Share: yup.boolean(),
    template_Body: yup.string()
});

interface Iprops {
    singleData: IEmailTemplate,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [tbody, settbody] = useState("");
    const [loading, setLoading] = useState(false);
    const toast = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IEmailTemplate>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const loadTemplate = async () => {
        setLoading(true);
        const response = await Fetch("Email_Template", "GET", null, null, toast);
        if (response) {
            const data: IEmailTemplate = await response.json();
            if (data.template_Body) settbody(data.template_Body);
            setLoading(false);
        } else setLoading(false);
    }

    useEffect(() => {
        loadTemplate();
        reset(props.singleData);
        if (props.singleData.template_Body)
            settbody(props.singleData.template_Body);
    }, [props.singleData])

    const saveToDB = async (body: IEmailTemplate) => {
        body.template_Body = tbody;
        const method = props.singleData.template_Id ? "PUT" : "POST";
        const message = props.singleData.template_Id ? "Updated Successfully" : "Added Successfully";
        const response = await Fetch("Email_Template", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }
    const onHide = () => {
        props.hideDialog();
        reset(EmptyEmailTemplate);
    }
    function onSubmit(data: IEmailTemplate) {
        if (tbody.length < 1) toast.current.show({ severity: 'error', detail: "Template Body is Required.", life: 3000 });
        else saveToDB(data);
    }
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Template" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Template Name " control={control} name="template_Name" error={errors.template_Name?.message} />
                <JVCheckbox required label="is Share" name="is_Share" control={control} />
                <JVInput column={1} required label="Template Subject " control={control} name="template_Subject" error={errors.template_Subject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label htmlFor="tbody">Template Body</label>
                    <JVSunEditor name="template_Body" value={tbody} handleChange={settbody}/>
                </div>
                {/* <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div> */}
                  <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
            <Toast ref={toast} />
        </Dialog>
    );
}
